module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImg2.094aae5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImg2.jpg
// module id = JmZt
// module chunks = 5